module.exports = __webpack_public_path__ + "img/pr-7.001e3aad.png";